import {
  Box,
  Button,
  DialogActions,
  TextField,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import DefaultModal from '../../../components/Modals/DefaultModal';
import { invoiceService } from '../../../services/invoiceService';

interface Props {
  openModal: boolean;
  closeModal: () => void;
  invoiceNumber: number;
  onConfirm: () => void;
}

const RejectInvoiceModal = (props: Props): JSX.Element => {
  const [rejectReason, setRejectReason] = useState<string>('');
  const [error, setError] = useState<boolean>(false);

  const handleConfirm = () => {
    if (rejectReason) {
      invoiceService
        .rejectInvoice({ invoiceId: props.invoiceNumber, rejectReason })
        .then(() => {
          props.closeModal();
          props.onConfirm();
        });
    } else {
      setError(true);
    }
  };

  return (
    <DefaultModal open={props.openModal} handleClose={props.closeModal}>
      <Box sx={{ px: 6 }}>
        <Typography variant="h4" textAlign="center" color="grey.900">
          Please provide a reason to reject Invoice #{props.invoiceNumber}
        </Typography>
        <TextField
          sx={{ width: '100%', my: 3 }}
          label="Please provide a reason ..."
          multiline
          rows={4}
          error={error}
          name="rejectReason"
          value={rejectReason}
          onChange={(event) => setRejectReason(event.target.value)}
        />
      </Box>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button onClick={handleConfirm} sx={{ width: '200px' }}>
          Confirm
        </Button>
      </DialogActions>
    </DefaultModal>
  );
};

export default RejectInvoiceModal;
